import { Api } from '@/services/Api'

const rootPath = '/cashbook/bank-account'

export default {
  get (pk) {
    return Api().get(`${rootPath}/${pk}/`)
  },
  list (entityId) {
    return Api().get(`${rootPath}/?entity=${entityId}`)
  },
  create (data) {
    return Api().post(`${rootPath}/`, data)
  },
  update (pk, data) {
    return Api().put(`${rootPath}/${pk}/`, data)
  },
  partial_update (pk, data) {
    return Api().patch(`${rootPath}/${pk}/`, data)
  },
  delete (pk) {
    return Api().delete(`${rootPath}/${pk}/`)
  }
}
